export default "__VITE_ASSET__DQiIQeE___"